import React from "react";
import { styles } from "../../stylesheets/simulateurs.css";
import ButtonYesno from "../buttons/button.yesno.js";
import Simulateur96 from "../../views/simulateurs/simulateur.A2.18/simulateur.A2.18";
import Simulateur97 from "../../views/simulateurs/simulateur.A2.19/simulateur.A2.19";
import BadgeNouveau from "../texts/BadgeNouveau.js";

function CautionPro(props) {
  const handleChange = async (setter, value, key) => {
    setter(value);
    props.handleChange(setter, value, key);
  };
  const handleDependance96 = (obj) => {
    props.handleChange(null, obj, 'simu96');
  };

  const handleDependance97 = (obj) => {
    props.handleChange(null, obj, 'simu97');
  };
  const sansGarantieHypoPro = props.sansGarantieHypoPro || 0;
  const avecGarantieHypoPro = props.avecGarantieHypoPro || 0;

  return (
    <>
      <div className="cardRow">
        <div style={styles.cardElemVerticalyCenter}>
          Y a-t-il un cautionnement pour prêts pro sans garantie hypothécaire ?
          <BadgeNouveau cliquable={false}/>
        </div>
        <ButtonYesno
          handleChange={handleChange}
          setter={props.setSansGarantieHypoPro}
          fieldUndefined={false}
          defaultValue={0}
          key="sansGarantieHypoPro"
        />
      </div>

      {parseInt(sansGarantieHypoPro) === 1 && (
        <Simulateur96
          simulateur={props.simulateur}
          isParent={false}
          departementId={props.departementId}
          dependances={handleDependance96}
          montantPret={props.montantPret}
        />
      )}

      <div className="cardRow">
        <div style={styles.cardElemVerticalyCenter}>
          Y a-t-il un cautionnement pour prêts pro avec garantie hypothécaire ?
          <BadgeNouveau cliquable={false}/>
        </div>
        <ButtonYesno
          handleChange={handleChange}
          setter={props.setAvecGarantieHypoPro}
          fieldUndefined={false}
          defaultValue={0}
          key="avecGarantieHypoPro"
        />
      </div>

      {parseInt(avecGarantieHypoPro) === 1 && (
        <Simulateur97
          simulateur={props.simulateur}
          isParent={false}
          departementId={props.departementId}
          dependances={handleDependance97}
          montantPret={props.montantPret}
        />
      )}
    </>
  );
}

export default CautionPro;
